
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vvxn7_296xd_93",
  "grid": "awsui_grid_vvxn7_296xd_128",
  "grid-no-gutters": "awsui_grid-no-gutters_vvxn7_296xd_133",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vvxn7_296xd_136",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vvxn7_296xd_143",
  "grid-columns-1": "awsui_grid-columns-1_vvxn7_296xd_146",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vvxn7_296xd_146",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vvxn7_296xd_149",
  "grid-columns-2": "awsui_grid-columns-2_vvxn7_296xd_152",
  "grid-columns-3": "awsui_grid-columns-3_vvxn7_296xd_158",
  "grid-columns-4": "awsui_grid-columns-4_vvxn7_296xd_164",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vvxn7_296xd_177",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vvxn7_296xd_210"
};
  